export default "__VITE_ASSET__DRPzaLE8__"